import React, { CSSProperties } from 'react';

interface ParkingProps {
  detailListStyle: CSSProperties
  parkingFeatures: Array<string> | undefined,
  garageYN: boolean | undefined
  attachedGarageYN: boolean | undefined,
  carportYN: boolean | undefined,
  carportSpaces: number | undefined
}

const Parking = ({detailListStyle, parkingFeatures, garageYN, attachedGarageYN, carportYN, carportSpaces} : ParkingProps) => {
	const gf: any =[];
	parkingFeatures?.map((p: string) => {
		return gf.push(p);
	});

	return parkingFeatures ? (
		<React.Fragment>
			<p className="text-uppercase cc-font-weight--bold mb-1">
				<i className="fal fa-parking me-2" />
        Parking
			</p>
			<ul style={detailListStyle}>
				{parkingFeatures && <li><span className="cc-font-weight--normal">Parking Features:</span> {gf.join(', ')}</li>}
				{garageYN || attachedGarageYN ? (
					<React.Fragment>
						<li><span className="cc-font-weight--normal">Garage:</span> Yes</li>
					</React.Fragment>
				) : (
					<li><span className="cc-font-weight--normal">Garage:</span> No</li>
				)}
				{carportYN ? (
					<React.Fragment>
						<li><span className="cc-font-weight--normal">Carport:</span> Yes</li>
						<li><span className="cc-font-weight--normal">Carport Spaces:</span> {carportSpaces}</li>
					</React.Fragment>
				) : (
					<li><span className="cc-font-weight--normal">Carport:</span> No</li>
				)}
			</ul>
		</React.Fragment>
	) : null;
};

export default Parking;
